import { usePageText } from "@/hooks/useCms";

const FALLBACK_ITEMS = [
  "Acreditação IPAC · I0016 · I0032",
  "Entidade Inspetora reconhecida pela DGEG",
  "Autorização IPQ · Equipamentos Sob Pressão",
  "+300.000 consumidores em segurança",
  "Grupo Gasmed · Hotinspe",
  "Cobertura nacional",
];

const HEX_RE = /^#([0-9a-f]{3}|[0-9a-f]{6})$/i;

export default function Marquee() {
  const { data } = usePageText("home-marquee", {
    eyebrow: "",
    title: "",
    intro_paragraphs: FALLBACK_ITEMS,
    settings: {
      enabled: true,
      speed_seconds: 60,
      accent_color: "#1698AC",
      separator_char: "✦",
      separator_size: 18,
    },
  });

  const s = data?.settings || {};
  const enabled = s.enabled !== false;
  if (!enabled) return null;

  const speed = Number(s.speed_seconds);
  const durationSec = Number.isFinite(speed) && speed > 0
    ? Math.min(180, Math.max(10, speed))
    : 60;
  const accent = typeof s.accent_color === "string" && HEX_RE.test(s.accent_color)
    ? s.accent_color
    : "#1698AC";
  const sepChar = typeof s.separator_char === "string" && s.separator_char.length > 0
    ? s.separator_char.slice(0, 4)
    : "✦";
  const rawSize = Number(s.separator_size);
  const sepSize = Number.isFinite(rawSize) && rawSize >= 10
    ? Math.min(48, Math.max(10, rawSize))
    : 18;

  const raw = Array.isArray(data?.intro_paragraphs) ? data.intro_paragraphs : [];
  const cleaned = raw.map((v) => (typeof v === "string" ? v.trim() : "")).filter(Boolean);
  const items = cleaned.length ? cleaned : FALLBACK_ITEMS;
  const row = [...items, ...items];

  return (
    <div
      className="border-y border-slate-200 dark:border-white/10 bg-[#F9FAFB] dark:bg-[#0D1320] py-5 overflow-hidden"
      data-testid="certifications-marquee"
    >
      <div
        className="marquee-track"
        style={{ animationDuration: `${durationSec}s` }}
      >
        {[0, 1].map((k) => (
          <div key={k} className="flex shrink-0">
            {row.map((it, i) => (
              <span
                key={`${k}-${i}`}
                className="flex items-center text-xs tracking-[0.22em] uppercase text-slate-500 font-medium whitespace-nowrap px-8"
              >
                {it}
                <span
                  className="ml-16 inline-flex items-center justify-center leading-none"
                  style={{ color: accent, fontSize: `${sepSize}px` }}
                  aria-hidden="true"
                >
                  {sepChar}
                </span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
